<template>
  <div class="card uptime-card">
    <div class="uptime-details">
      <div class="uptime-text">
        <span><strong>Uptime: </strong>{{100 - downtime.percent}}%</span>
        <span>&nbsp;&nbsp;</span>
        <span><strong>Total Time: </strong>{{friendlyDuration(downtime.total)}}</span>
        <span>&nbsp;&nbsp;</span>
        <span><strong>MTTA: </strong>{{friendlyDuration(mean(alerts, 'ackTime'))}}</span>
        <span>&nbsp;&nbsp;</span>
        <span><strong>MTTC: </strong>{{friendlyDuration(mean(alerts, 'closeTime'))}}</span>
      </div>
    </div>
    <div class="uptime-bar">
      <div class="uptime-bar-green" :style="{'width': 100 - downtime.percent +'%'}"></div>
      <div class="uptime-bar-red" :style="{'width': downtime.percent +'%'}"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Uptime',
  props: [
    'downtime',
    'alerts'
  ],
  methods: {
    mean: function (alerts, type) {
      var total = 0

      if (!('P1' in alerts)) {
        return total
      }

      for (const alert of alerts.P1) {
        total += alert[type] - alert['timestamp']
      }

      return total / alerts.P1.length
    },
    friendlyDuration: function (seconds) {
      // use dummy date to calulate the amount of hours, minutes and seconds from seconds
      // dosn't matter what 2015-01-01 is
      var format = 's [seconds]'
      if (seconds > 59) {
        format = 'm [minutes] ' + format
      }
      if (seconds > 3599) {
        format = 'H [hours] ' + format
      }
      return this.$moment('2015-01-01').startOf('day').seconds(seconds).format(format)
    }
  }
}
</script>

<style scoped src='@/assets/stylesheet/components/uptime.css'></style>



// WEBPACK FOOTER //
// src/components/Alerts/Uptime.vue